import { isValid } from 'date-fns';
const validateBirthDate = (birthDate) => {
    const birthDateErrors = [];
    const today = new Date();
    const toDate = new Date(birthDate.replace(/(\d{2})-(\d{2})-(\d{4})/, '$2/$1/$3'));
    if (birthDate === '') {
        birthDateErrors.push('Required');
    }
    if (birthDate.length < 10) {
        birthDateErrors.push('We need your full birth date');
    }
    if (today <= toDate) {
        birthDateErrors.push('Current or future date is not valid.');
    }
    if (!isValid(toDate)) {
        birthDateErrors.push('Date is not valid');
    }
    return birthDateErrors;
};
export default validateBirthDate;
//# sourceMappingURL=validate-birth-date.js.map